// extracted by mini-css-extract-plugin
export default {"component":"AnimatedBackground_component__6pv-O","point":"AnimatedBackground_point__UII5m"};